import { getSessionStorageItemJson } from '@vfde-sails/storage';
import { getQueryParam } from '@vfde-sails/utils';
import {
    PARAM_OFFER_ID,
    SAILS_GK_LP_STORAGE,
} from 'Constant';
import { updateMultipicker } from 'Container/Landingpage/helpers/components/multipickerHelper';
import { IOfferKeyElements, retrieveFromOfferId } from './offerDataHelper';
import { SailsGkLandingpageStorage } from 'Container/Storage';

/**
 * The selected tariff when the page loads follows the hierarchy below:
 * Hierarchy: URL Parameter > Session Storage > CMS
 */
export const preselectMultipickerOnLoad = (multiPickerHas, multiPickerWants): IOfferKeyElements => {
    // get Elements to be preselected from URL or from session storage
    // we can rely on that the offerId is either valid or nurr
    const toBePreselected = getParamForPreselection() || getSessionStorageForPreselection();
    let offerIdElements: IOfferKeyElements = null;

    if (null !== toBePreselected) {
        offerIdElements = retrieveFromOfferId(toBePreselected);
        updateMultipicker(multiPickerHas, multiPickerWants, offerIdElements);
    }

    return offerIdElements;

};

/**
 * The selected tariff when the page loads follows the hierarchy below:
 * Hierarchy: URL Parameter > Session Storage > CMS
 */
export const adjustMultipickerSelections = (recently_clicked_option: string, offerKeys: IOfferKeyElements ): IOfferKeyElements => {

    switch (recently_clicked_option) {
        case 'has_none':
            offerKeys.has_tv = false;
            offerKeys.has_mobilfunk = false;
            offerKeys.has_internet = false;
            break;
        case 'has_tv':
        case 'has_internet':
        case 'has_mobilfunk':
            offerKeys.has_none = false;
            break;
        case 'wants_tv':
        case 'wants_mobilfunk':
        case 'wants_internet':
        case 'wants_redplus':
            if ( false === offerKeys.has_tv
                && false === offerKeys.has_mobilfunk
                && false === offerKeys.has_internet
                && false === offerKeys.has_none) {
                offerKeys.has_none = true;
            }
            break;
    }

    return offerKeys;

};

/**
 * Check, if offerId is a valid one:
 * - must not be empty
 * - must be 8 char
 * - only numbers (0 and 1) are allowed
 * @param offerId
 */
const isOfferIdValid = (offerId: string): boolean => {

    // every string that doesn't consist of 8 chars is invalid
    if ( 8 !== offerId?.length) {

        return false;
    }

    // each string, that includes other than "0" or "1" is invalid
    if (null === offerId.match('^[01]+$')) {

        return false;
    }

    return true;

};

/**
 * returns offerId from URL param
 */
const getParamForPreselection = (): string => {

    // get Parameter offerId from URL Param
    const param_preselect = getQueryParam(PARAM_OFFER_ID);
    let ret = null;

    if (isOfferIdValid(param_preselect)) {
        ret = param_preselect;
    }

    return ret;
};

/**
 * returns offerId from session storage
 */
const getSessionStorageForPreselection = (): string | null => {

    // get offerId from Session Storage
    const session_storage_preselect = getSessionStorageItemJson(SAILS_GK_LP_STORAGE) as SailsGkLandingpageStorage;
    let ret = null;

    if (session_storage_preselect !== null && 'object' === typeof session_storage_preselect && Object.prototype.hasOwnProperty.call(session_storage_preselect, 'multipickerSelection') && 'string' === typeof session_storage_preselect.multipickerSelection) {
        if (isOfferIdValid(session_storage_preselect.multipickerSelection)) {
            ret = session_storage_preselect.multipickerSelection;
        }
    }

    return ret;

};
